module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("6bD26"))).then(() => parcelRequire('4T4hn'));